import React from 'react';

export default function SkeletonLoader({style, className}) {
  return (
    <div className={`skeleton ${className}`} style={style}>
      <div className="s-line first" />
    </div>
  );
}
